import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { SearchSchema } from "./-schemas";

export const Route = createFileRoute("/_staff/apps/_list/people/")({
  validateSearch: zodValidator(SearchSchema),
  loaderDeps: ({ search }) => ({ search }),
});
